import NextImage from 'next/image'
import { type InstructorQuote as InstructorQuoteData } from '@mc/growth-data'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { type PrunedCourse } from 'libs/server/api'
import { CM_INSTRUCTOR_QUOTE_I18N_NAMESPACE } from '../i18n'
import styles from './InstructorQuote.module.scss'

const AVATAR_SIZE = 48

export const InstructorQuote = ({
  quote: { quote, instructor, attributionTopic },
}: {
  quote: InstructorQuoteData
}) => {
  const { t } = useTranslation(CM_INSTRUCTOR_QUOTE_I18N_NAMESPACE)
  const { course } = useStaticData<{ course: PrunedCourse }>()

  return (
    <div className='mc-pb-2 mc-pt-lg-2 mc-pb-lg-6'>
      <figure className={`${styles.centered} mc-my-0`}>
        <span aria-hidden className={styles.glyph}>
          &ldquo;
        </span>
        <blockquote className={`${styles.quote} mc-mb-0`}>{quote}</blockquote>
        <div aria-hidden className='mc-nameplate__separator' />
        <figcaption className='d-flex align-items-center justify-content-center mc-gap-3'>
          {course.primary1x1 && (
            <NextImage
              src={course.primary1x1}
              alt=''
              width={AVATAR_SIZE}
              height={AVATAR_SIZE}
              className={`${styles.avatar} mc-corners--circle flex-shrink-0`}
            />
          )}
          <span className='mc-text--left'>
            <span
              className={`${styles.name} d-block mc-text-small mc-text--uppercase`}
            >
              {instructor}
            </span>
            <span className='d-block mc-text-small mc-text-color--medium'>
              {t('topic', { topic: attributionTopic })}
            </span>
          </span>
        </figcaption>
      </figure>
    </div>
  )
}
